module.exports = __webpack_public_path__ + "static/img/shape_17.6624976.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/shape_17.png
// module id = rU5R
// module chunks = 0